
import { AuthForm } from "@/components/auth/AuthForm";
import { Link } from "react-router-dom";

const Login = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <div className="text-center mb-8 w-full max-w-md mx-auto">
        <Link to="/">
          <img 
            src="/lovable-uploads/d62a4e07-f701-4335-84a0-c9be341a0477.png" 
            alt="Bright Stages" 
            className="h-24 md:h-28 lg:h-32 mx-auto mb-6 transition-all duration-300 hover:scale-105"
          />
        </Link>
        <p className="text-gray-600 text-lg">Track your children's growth and achievements</p>
      </div>
      <AuthForm mode="login" />
      <p className="mt-4 text-sm text-gray-600">
        Don't have an account?{" "}
        <a href="/signup" className="text-primary font-semibold hover:underline">
          Sign up
        </a>
      </p>
    </div>
  );
};

export default Login;
